import styled from 'styled-components'

export const FlexSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 12px;
  }
`

export const PageContent = styled.div`
  padding: 0;
  @media (max-width: 767px) {
    padding: 0 4px;
  }
`
